import { Dispatch, SetStateAction, useState } from "react";
import { useForm } from "react-hook-form";

import { Block } from "components/Layout";
import Button from "components/Button";
import Input from "/components/Form/Input";

import styles from "./LoginStep1.module.scss";
import postData from "/utils/postData";
import { useSearchParams } from "next/navigation";

type LoginStep1Props = {
  setTokenSent: Dispatch<SetStateAction<boolean>>;
  setPhoneNumber: Dispatch<SetStateAction<string>>;
};

function LoginStep1({ setTokenSent, setPhoneNumber }: LoginStep1Props) {
  const [errorMessage, setErrorMessage] = useState("");

  const { register, handleSubmit, errors, formState } = useForm();
  const searchParams = useSearchParams();
  const referer = searchParams?.get("referer");

  const onSubmit = async (data: { phoneNumber: string }) => {
    setErrorMessage("");

    try {
      const phoneNumber = "47" + data.phoneNumber;
      await postData("/api/auth/login/step1", { phoneNumber, referer });

      setTokenSent(true);
      setPhoneNumber(phoneNumber);
    } catch (error) {
      setErrorMessage(error.message);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <form onSubmit={handleSubmit(onSubmit)} data-animate-in data-animation-order="1">
          <Input
            data-testid="login-step1-input"
            name="phoneNumber"
            type="tel"
            label="Hva er telefonnummeret ditt?"
            widthCharacters="24"
            maxLength="8"
            register={register({
              required: "Skriv ditt mobilnummer, 8 siffer",
              pattern: {
                value: /^[0-9]*$/,
                message: "Skriv ditt mobilnummer, 8 siffer"
              },
              minLength: {
                value: 8,
                message: "Skriv ditt mobilnummer, 8 siffer"
              }
            })}
            error={errors.phone}
            autoFocus
          />

          {errorMessage && (
            <Block top={5}>
              <p className="color--red">{errorMessage}</p>
            </Block>
          )}

          <Block top={6}>
            <Button
              data-testid="login-step1-submit"
              type="submit"
              primary
              disabled={formState.isSubmitting}
              isSubmitting={formState.isSubmitting}
              errors={errors}
            >
              Send engangskode på SMS
            </Button>
          </Block>
        </form>
      </div>
    </div>
  );
}

export default LoginStep1;
